export enum DialogsReturnCode
{
    LOGIN_FORCED_ACCEPT    ,
    LOGIN_FORCED_CANCELL   ,
    PASSWORD_CHANGE_ACCEPT ,
    PASSWORD_CHANGE_CANCELL,

    OPERATION_ACCEPTED         ,
    OPERATION_DECLINED         ,
    OPERATOR_ACCEPTED          ,
    MESSAGE_OPERATION_ACCEPTED ,
    SERVICE_OPERATION_ACCEPTED ,
    CALENDAR_OPERATION_ACCEPTED,
    SLOT_OPERATION_ACCEPTED    ,
    SLOT_MASS_IMPORT_ACCEPTED  ,
    PRENOTATION_DELETE,

    SLOTMODEL_AUTO,
    SLOTMODEL_MODEL,
    SLOTMODEL_SLOT
}